<template>
  <div class="page_programme">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px" v-if="activeName=='first'">
            <el-form-item label="险种名称" size="small">
              <el-input v-model="listQuery.InsuranceName" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="服务商" size="small">
              <el-select v-model="listQuery.ServerName" placeholder="" size="small" clearable filterable>
                <el-option v-for="(item, index) in serviceList" :key="index" :label="item.ServiceProviderName" :value="item.ServiceProviderName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商保类别" size="small">
              <el-select v-model="listQuery.Bntype" size="small" placeholder="" clearable filterable>
                <el-option v-for="(item, index) in bntList" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>商保管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName=='first' ? '险种管理' : '订单/保单管理'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="险种管理" name="first"></el-tab-pane>
          <el-tab-pane label="订单/保单管理" name="second"></el-tab-pane>
          <el-tab-pane label="投保明细" name="3"></el-tab-pane>
          <el-tab-pane label="核对名单" name="4"></el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px;" class="flex">
          <el-button type="primary" size="small" v-if="activeName=='first'" @click="addNewPlan">&nbsp;新增险种+</el-button>
          <el-popconfirm :title="`请确认是否为选中的${multipleSelection.length}条订单生成保单号？`" v-preventReClick v-if="activeName=='first'" @confirm="generateNum" style="margin:0 10px">
            <el-button slot="reference" size="small" type="warning">生成保单号</el-button>
          </el-popconfirm>
          <el-button size="small" type="success" v-if="activeName=='3'" @click="BuildTime('BuildTime')">生成保单时间</el-button>
          <el-button size="small" type="success" v-if="activeName=='4'" @click="BuildTime('BuildCheck')">核对名单</el-button>
          <!-- <el-button type="primary" size="small" v-if="activeName=='second'" @click="showAddInsurance = true">&nbsp;新增保单+</el-button> -->
          <!-- <el-button type="success" size="small">&nbsp;导出</el-button> -->
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" v-if="activeName=='first'" @selection-change="handleSelectionChange" row-key="tab">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column prop="Sort" label="序号" width="60" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="InsuranceCode" label="保障方案ID" width="90" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Bntype" label="商保类别" width="310" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="InsuranceProduct" label="投保产品" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column prop="AdditPlan" label="附加险方案" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column prop="ProtecName" label="保障方案名称" :show-overflow-tooltip="true" align="center" width="140">
          </el-table-column>

          <el-table-column prop="TypeWork" label="工种类型" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Price" label="投保金额（元）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ClaimsPrice" label="理赔上限（元）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ServerName" label="服务商" width="140" align="center" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="ContactPerson" label="对接人" width="100" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.ContactPersonId)" v-show="row.ContactPersonId && row.ContactPerson" title="点击查看联系方式">{{row.ContactPerson}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="Remark" label="说明" width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="附件" width="80" align="center">
            <template slot-scope="{row}">
              <span class="info_item_sys cp" v-if="row.AttachmentUrl" @click="down(docPath + row.AttachmentUrl)">下载</span>
            </template>
          </el-table-column>
          <el-table-column prop="ValidityStartTime" label="生效日期" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ValidityEndTime" label="失效日期" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ServerName" label="服务商" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ProjectName" label="服务商险种名称" :show-overflow-tooltip="true" align="center" width="120px">
          </el-table-column>
          <el-table-column prop="Price" label="保费价格" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="SupportPeriodUnit" label="保单周期" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="SupportPeriod" label="周期数" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Enabled" label="启用状态" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="SafeguardStatement" label="保障说明" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="Name" label="可投保保单" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="Name" label="操作" align="center" fixed="right" width="200px">
            <template slot-scope={row}>
              <div class="eleTabBtn">
                <el-button type="text" v-preventReClick @click="editPlan(row)" style="margin-right:10px;">编辑</el-button>
                <el-popconfirm :title="row.Enabled=='已停用' ? '请确认是否启用' : '请确认是否停用'" v-preventReClick @confirm="stopPlan(row)">
                  <el-button slot="reference" type="text">{{row.Enabled=='已停用' ? '启用' : '停用'}}</el-button>
                </el-popconfirm>
                <el-button type="text" v-preventReClick @click="importTemp(row)" style="margin-left:10px;">上传模板</el-button>
                <el-popconfirm title="请确认是否删除" v-preventReClick @confirm="delPlan(row)" style="margin-left:10px">
                  <el-button slot="reference" type="text">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="tableData2" border class="doc_table" v-loading="loading" style="width:100%" v-if="activeName!='first'" row-key="tab2">
          <template v-if="activeName=='second'">
            <el-table-column prop="OrderCode" label="订单号" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="InsuranceNum" label="保单号" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ServiceProvider" label="服务商" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="InsuranceName" label="险种名称" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="InsurancePrice" label="保费价格" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CoverStartTime" label="保障开始日期" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                {{ row.CoverStartTime ? row.CoverStartTime.split('T')[0] : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="CoverEndTime" label="保障截止日期" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                {{ row.CoverEndTime ? row.CoverEndTime.split('T')[0] : '' }}
              </template>
            </el-table-column>
          </template>
          <template v-if="activeName=='3'">
            <el-table-column label="商保类别" :show-overflow-tooltip="true" align="center" key="1.1" min-width="140" fixed="left">
              <template slot-scope={row}>
                <span v-if="row.Info.Bntype!=undefined && row.Info.Bntype">{{ row.Info.Bntype }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="State" label="状态" :show-overflow-tooltip="true" align="center" key="1.2" min-width="140">
            </el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" :show-overflow-tooltip="true" align="center" key="2" min-width="140">
            </el-table-column>
            <el-table-column prop="Count" label="投保人数" :show-overflow-tooltip="true" align="center" key="3" min-width="100">
            </el-table-column>
            <el-table-column prop="SuccessCount" label="成功人数" :show-overflow-tooltip="true" align="center" key="4" min-width="100">
            </el-table-column>
            <el-table-column prop="Begin" label="开始时间" :show-overflow-tooltip="true" align="center" key="5" min-width="140">
              <template slot-scope={row}>
                {{ row.Begin ? row.Begin.split('T')[0] : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="结束时间" :show-overflow-tooltip="true" align="center" key="6" min-width="140">
              <template slot-scope={row}>
                {{ row.End ? row.End.split('T')[0] : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="AttachPsrsonUrl" label="保单人员excel" :show-overflow-tooltip="true" align="center" key="7" min-width="100">
              <template slot-scope={row}>
                <div class="blueName cp" v-if="row.AttachPsrsonUrl" @click="down(excelPath + row.AttachPsrsonUrl)">下载</div>
              </template>
            </el-table-column>
            <el-table-column prop="AttachFileUrl" label="营业执照" :show-overflow-tooltip="true" align="center" key="8" min-width="100">
              <template slot-scope={row}>
                <div class="blueName cp" v-if="row.AttachFileUrl" @click="down(row.AttachFileUrl)">下载</div>
              </template>
            </el-table-column>
          </template>
          <template v-if="activeName=='4'">
            <el-table-column prop="GnteeName" label="商保类别" :show-overflow-tooltip="true" align="center" fixed="left" key="1" min-width="180">
            </el-table-column>
            <el-table-column prop="SysCount" label="在保人数" :show-overflow-tooltip="true" align="center" key="4" min-width="100">
            </el-table-column>
            <el-table-column prop="CloudCount" label="商保公司人数" :show-overflow-tooltip="true" align="center" key="5" min-width="100">
            </el-table-column>
            <el-table-column prop="TodayReduce" label="今日减员" :show-overflow-tooltip="true" align="center" key="12" min-width="100">
            </el-table-column>
            <el-table-column prop="TodayAdd" label="今日增员" :show-overflow-tooltip="true" align="center" key="12" min-width="100">
            </el-table-column>
            <el-table-column prop="FourCount" label="四类人数" :show-overflow-tooltip="true" align="center" key="6" min-width="100">
            </el-table-column>
            <el-table-column prop="FourPrice" label="四类单价" :show-overflow-tooltip="true" align="center" key="7" min-width="100">
            </el-table-column>
            <el-table-column prop="FourTotal" label="四类总计" :show-overflow-tooltip="true" align="center" key="8" min-width="100">
            </el-table-column>
            <el-table-column prop="FiveCount" label="五类人数" :show-overflow-tooltip="true" align="center" key="9" min-width="100">
            </el-table-column>
            <el-table-column prop="FivePrice" label="五类单价" :show-overflow-tooltip="true" align="center" key="10" min-width="100">
            </el-table-column>
            <el-table-column prop="FiveTotal" label="五类总计" :show-overflow-tooltip="true" align="center" key="11" min-width="100">
            </el-table-column>
            <el-table-column prop="Total" label="总计" :show-overflow-tooltip="true" align="center" key="12" min-width="100">
            </el-table-column>
            <el-table-column prop="Text" fixed="left" label="备注" :show-overflow-tooltip="true" align="center" key="2" min-width="100">
            </el-table-column>
            <el-table-column prop="CreateTime" fixed="left" label="创建时间" :show-overflow-tooltip="true" align="center" key="3" min-width="160">
            </el-table-column>
            <el-table-column prop="GnteeId" label="方案id" :show-overflow-tooltip="true" align="center" key="13" min-width="80">
            </el-table-column>
            <el-table-column prop="OrderCode" label="保单号" :show-overflow-tooltip="true" align="center" key="14" min-width="180">
            </el-table-column>
          </template>
          <!-- <el-table-column prop="Name" label="操作" align="center">
            <template slot-scope={row}>
              <div class="eleTabBtn">
                <el-button type="text" v-preventReClick>编辑</el-button>
                <el-button type="text" v-preventReClick>停用</el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增险种" :visible.sync="showAddPlan" width="980px">
      <div class="planForm">
        <el-form :model="planForm" :inline="true" ref="planForm" :rules="planRules" label-width="130px">
          <!-- <div class="formTitle" style="margin-top: 0;">基本信息</div> -->
          <el-form-item label="服务商" prop="InsuranceManage.ServerName">
            <el-select v-model="planForm.InsuranceManage.ServerName" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option v-for="(item, index) in serviceList" :key="index" :label="item.ServiceProviderName" :value="item.ServiceProviderName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务商险种名称" prop="InsuranceManage.ProjectName">
            <!-- <el-select v-model="planForm.ProjectName" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option v-for="(item,index) in planList" :key="index" :value="item"></el-option>
            </el-select> -->
            <el-input v-model="planForm.InsuranceManage.ProjectName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="投保产品" prop="InsuranceProduct">
            <el-input v-model="planForm.InsuranceManage.InsuranceProduct" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="附加险方案" prop="AdditPlan">
            <el-input v-model="planForm.InsuranceManage.AdditPlan" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保障方案ID" prop="InsuranceCode">
            <el-input v-model="planForm.InsuranceManage.InsuranceCode" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保障方案名称" prop="ProtecName">
            <el-input v-model="planForm.InsuranceManage.ProtecName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="商保类别" prop="Bntype">
            <!-- <el-select v-model="planForm.InsuranceManage.Bntype" placeholder="" clearable size="small" style="width:300px">
              <el-option v-for="(item, index) in bntList" :key="index" :value="item"></el-option>
            </el-select> -->
            <el-input v-model="planForm.InsuranceManage.Bntype" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="投保金额(元)" prop="Price">
            <el-input v-model="planForm.InsuranceManage.Price" size="small" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="理赔上限(元)" prop="ClaimsPrice">
            <el-input v-model="planForm.InsuranceManage.ClaimsPrice" size="small" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="工种类型" prop="TypeWork">
            <el-select v-model="planForm.InsuranceManage.TypeWork" placeholder="" clearable multiple size="small" style="width:300px">
              <el-option value="一类"></el-option>
              <el-option value="二类"></el-option>
              <el-option value="三类"></el-option>
              <el-option value="四类"></el-option>
              <el-option value="五类"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="对接人">
            <el-select v-model="planForm.InsuranceManage.ContactPerson" value-key="Userid" placeholder="" clearable filterable @change="changePerson" size="small" style="width:300px">
              <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="说明" prop="Remark">
            <el-input type="textarea" v-model="planForm.InsuranceManage.Remark" :autosize="{ minRows: 4 }" maxlength="500" show-word-limit size="small" style="width:300px"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="附件" prop="name1">
              <div class="upload_box">
                <el-upload class="upload-demo" action="" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
                  <el-button size="small" type="success">上传附件</el-button>
                </el-upload>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="保障周期" prop="SupportPeriod">
            <div class=" flex aic">
              <el-select v-model="planForm.InsuranceManage.SupportPeriodUnit" placeholder="" size="small" clearable filterable style="width:145px">
                <el-option value="月单"></el-option>
                <el-option value="年单"></el-option>
                <el-option value="半年单"></el-option>
                <el-option value="季度单"></el-option>
              </el-select>
              <el-input v-model="planForm.InsuranceManage.SupportPeriod" type="number" style="width:145px;margin-left: 10px;" size="small">
                <template slot="append">周期</template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="男女比例限制" prop="MaleRatio">
            <div class=" flex aic">
              <el-input v-model="planForm.InsuranceManage.MaleRatio" style="width:145px" size="small" placeholder="男性比例"></el-input>
              <el-input v-model="planForm.InsuranceManage.FemaleRatio" style="width:145px;margin-left: 10px" size="small" placeholder="女性比例"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="年龄限制" prop="AgelimitStart">
            <div class=" flex aic">
              <el-input v-model="planForm.InsuranceManage.AgelimitStart" style="width:143px" size="small"></el-input>
              <div style="margin: 0 5px;">-</div>
              <el-input v-model="planForm.InsuranceManage.AgelimitEnd" style="width:143px" size="small"></el-input>
            </div>
          </el-form-item>

          <el-form-item label="有效期" prop="ValidityStartTime">
            <div class=" flex aic">
              <el-date-picker type="date" placeholder="" v-model="planForm.InsuranceManage.ValidityStartTime" value-format="yyyy-MM-dd" style="width:143px" size="small"></el-date-picker>
              <div style="margin: 0 5px;">-</div>
              <el-date-picker type="date" placeholder="" v-model="planForm.InsuranceManage.ValidityEndTime" value-format="yyyy-MM-dd" style="width:143px" size="small"></el-date-picker>
            </div>
          </el-form-item>

          <el-form-item label="医保类型" prop="MedicalinsuranceType">
            <el-select v-model="planForm.InsuranceManage.MedicalinsuranceType" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option value="城镇职工"></el-option>
              <el-option value="城镇居民"></el-option>
              <el-option value="新型农村合作医疗"></el-option>
              <el-option value="均为参加"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否允许报减" prop="InsuranceManage.IsCanDeduction">
            <el-radio v-model="planForm.InsuranceManage.IsCanDeduction" label="是">是</el-radio>
            <el-radio v-model="planForm.InsuranceManage.IsCanDeduction " label="否">否</el-radio>
          </el-form-item>

          <el-form-item label="保障说明" prop="SafeguardStatement">
            <el-input v-model="planForm.InsuranceManage.SafeguardStatement" style="width:300px" size="small"></el-input>
          </el-form-item>

          <div class="formTitle">基础配置</div>

          <el-form-item label="序号" prop="Sort">
            <el-input type="number" v-model="planForm.InsuranceManage.Sort" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="岗位批注" prop="JobName">
            <el-input v-model="planForm.InsuranceManage.JobName" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="职业类别批注" prop="JobClasss">
            <el-input v-model="planForm.InsuranceManage.JobClasss" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="职业类别选项" prop="EmployeeAttribute">
            <el-select v-model="planForm.InsuranceManage.EmployeeAttribute" placeholder="" clearable multiple size="small" style="width:300px">
              <el-option value="1-4类"></el-option>
              <el-option value="5类"></el-option>
            </el-select>
          </el-form-item>


          <div class="priceBox">
            <div class="formTitle">成本价格</div>
            <div class="costItem" v-for="(item,index) in planForm.CostList" :key="index">
              <el-form-item label="岗位类别">
                <el-select v-model="item.JobCategory" placeholder="" clearable size="small" style="width:80px">
                  <el-option value="一类"></el-option>
                  <el-option value="二类"></el-option>
                  <el-option value="三类"></el-option>
                  <el-option value="四类"></el-option>
                  <el-option value="五类"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="价格" label-width="50px">
                <div class=" flex aic">
                  <el-select v-model="item.PriceUnit" placeholder="" size="small" clearable filterable style="width:110px">
                    <el-option value="按元/日/人"></el-option>
                    <el-option value="按元/半月/人"></el-option>
                    <el-option value="按元/季度/人"></el-option>
                    <el-option value="按元/半年/人"></el-option>
                    <el-option value="按元/年/人"></el-option>
                  </el-select>
                  <el-input v-model="item.Price" style="width:80px;margin-left: 10px;" size="small">
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="成本" label-width="50px">
                <div class=" flex aic">
                  <el-select v-model="item.CostUnit" placeholder="" size="small" clearable filterable style="width:110px">
                    <el-option value="按元/日/人"></el-option>
                    <el-option value="按元/半月/人"></el-option>
                    <el-option value="按元/季度/人"></el-option>
                    <el-option value="按元/半年/人"></el-option>
                    <el-option value="按元/年/人"></el-option>
                  </el-select>
                  <el-input v-model="item.Cost" style="width:80px;margin-left: 10px;" size="small">
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="备注" label-width="50px">
                <el-input v-model="item.Remark" style="width:100px" size="small"></el-input>
              </el-form-item>
              <span class="txtBtb blueName cp" v-if="index>0" @click="delCost(index)">删除</span>
            </div>
            <div class="addCost greenName cp" @click="addCost">新增+</div>
          </div>
          <div class="priceBox">
            <el-form-item label="险种权限" prop="InsuranceAuthority">
              <div style="width: 300px;">
                <el-radio v-model="planForm.InsuranceManage.InsuranceAuthority" label="所有人可见">所有人可见</el-radio>
                <el-radio v-model="planForm.InsuranceManage.InsuranceAuthority" label="部分可见">部分可见</el-radio>
              </div>
            </el-form-item>
            <el-form-item label="可见账户" prop="name" v-if="planForm.InsuranceManage.InsuranceAuthority=='部分可见'">
              <el-select v-model="planForm.distributionList" value-key="Userid" placeholder="" clearable filterable multiple size="small" style="width:300px">
                <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Strorganname + '-' + item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddPlan = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmSavePlan" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增保单" :visible.sync="showAddInsurance" width="980px">
      <div class="planForm">
        <el-form :model="planForm" :inline="true" ref="planForm" :rules="planRules" label-width="130px">
          <el-form-item label="服务商" prop="name">
            <el-select v-model="planForm.name" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option v-for="(item,index) in serviceList" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="险种名称" prop="name">
            <el-select v-model="planForm.name" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option v-for="(item,index) in planList" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="男女比例限制" prop="name">
            <div class=" flex aic">
              <el-input v-model="planForm.name" style="width:145px" size="small" placeholder="男性比例"></el-input>
              <el-input v-model="planForm.name" style="width:145px;margin-left: 10px" size="small" placeholder="女性比例"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="年龄限制" prop="name">
            <div class=" flex aic">
              <el-input v-model="planForm.name" style="width:143px" size="small"></el-input>
              <div style="margin: 0 5px;">-</div>
              <el-input v-model="planForm.name" style="width:143px" size="small"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="保障期限" prop="name">
            <div class=" flex aic">
              <el-date-picker type="date" placeholder="" v-model="planForm.name" value-format="yyyy-MM-dd" style="width:143px" size="small"></el-date-picker>
              <div style="margin: 0 5px;">-</div>
              <el-date-picker type="date" placeholder="" v-model="planForm.name" value-format="yyyy-MM-dd" style="width:143px" size="small"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="险种保费价格" prop="name">
            <div class=" flex aic">
              <el-select v-model="planForm.name" placeholder="" size="small" clearable filterable style="width:145px">
                <el-option value="按元/日/人"></el-option>
                <el-option value="按元/半月/人"></el-option>
                <el-option value="按元/季度/人"></el-option>
                <el-option value="按元/半年/人"></el-option>
                <el-option value="按元/年/人"></el-option>
              </el-select>
              <el-input v-model="planForm.name" style="width:145px;margin-left: 10px;" size="small">
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="保障说明" prop="name">
            <el-input v-model="planForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="医保类型" prop="name">
            <el-select v-model="planForm.name" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option value="城镇职工"></el-option>
              <el-option value="城镇居民"></el-option>
              <el-option value="新型农村合作医疗"></el-option>
              <el-option value="均为参加"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否允许报减" prop="name">
            <el-radio v-model="planForm.name" label="1">是</el-radio>
            <el-radio v-model="planForm.name" label="0">否</el-radio>
          </el-form-item>
          <div>
            <el-form-item label="险种权限" prop="p">
              <div style="width: 300px;">
                <el-radio v-model="planForm.p" label="1">所有人可见</el-radio>
                <el-radio v-model="planForm.p" label="0">部分可见</el-radio>
              </div>
            </el-form-item>
            <el-form-item label="可见账户" prop="name" v-if="planForm.p=='0'">
              <el-select v-model="planForm.name" value-key="Userid" placeholder="" clearable filterable multiple size="small" style="width:300px">
                <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Strorganname + '-' + item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddInsurance = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="showAddInsurance = false" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="上传模板" :visible.sync="showImportTemp" width="600px">
      <el-form ref="planForm" label-width="130px">
        <el-form-item label="商保类别" prop="name">
          <el-input v-model="Bntype" style="width:300px" size="small" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="上传模板" prop="url">
          <div class="file-box">
            <input readonly style="width: 300px;height:32px;margin-top: 4px;" id="applyLicense" type="text" v-model="fileName" autocomplete="off">
            <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
            <label for="fileInput" class="file-btn cp">上传</label>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImportTemp = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmImportTemp" size="small" :disabled="!isUploadSuccess || !tempForm.FileBase64">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    nextTick
  } from 'vue';
  export default {
    data() {
      return {
        listQuery: {
          InsuranceName: '', //险种名称
          ServerName: '', //服务商
          Bntype: '', //商保类别
          pageNum: 1,
          pageSize: 10,
        },
        serviceList: [], //服务商列表
        planList: ['险种1', '险种2'], //服务商险种列表
        showDropScreen: -1,
        activeName: 'first',
        loading: false,
        tableData: [],
        showAddPlan: false, //新增险种弹窗
        headPath: this.$store.state.EMP.docPath,
        excelPath: this.$store.state.EMP.tablePath,
        planForm: {
          InsuranceManage: {
            id: '',
            ServerName: '', //服务商名称
            ProjectName: '', //商保险种名称
            InsuranceProduct: '', //投保产品
            AdditPlan: '', //附加险方案
            ProtecName: '', //保障方案名称
            Bntype: '', //商保类别
            Price: '', //投保金额
            ContactPerson: '', //对接人
            ContactPersonID: '',
            AttachmentUrl: '',
            ClaimsPrice: '', //理赔上限
            TypeWork: '', //工种类型
            SupportPeriodUnit: '', //保障周期单位
            SupportPeriod: '', //保障周期
            MaleRatio: '', //男性比例
            FemaleRatio: '', //女性比例
            AgelimitStart: '', //年龄限制
            AgelimitEnd: '', //年龄限制
            ValidityStartTime: '', //有效期
            ValidityEndTime: '', //有效期
            MedicalinsuranceType: '', //医保类型
            IsCanDeduction: '', //是否允许报减
            SafeguardStatement: '', //保障说明
            InsuranceAuthority: '', //权限范围
            Enabled: '启用中',
            EmployeeAttribute: '', //职业类别选项
            JobClasss: '', //职业类别批注
            JobName: '', //岗位批注
            Sort: null, //序号
          },
          distributionList: [], //可见账户
          CostList: [{
            JobCategory: '', //岗位类别
            PriceUnit: '', //价格单位
            Price: '', //价格
            CostUnit: '', ///成本单位
            Cost: '', //成本
            Remark: ''
          }]
        },
        totalCount: 0,
        fileList: [],
        planRules: {
          'InsuranceManage.ServerName': {
            required: true,
            message: "请选择服务商名称",
            trigger: "change",
          },
          'InsuranceManage.ProjectName': {
            required: true,
            message: "请输入服务商险种名称",
            trigger: "blur",
          },
          'InsuranceManage.IsCanDeduction': {
            required: true,
            message: "请选择是否允许报减",
            trigger: "change",
          },
        },
        multipleSelection: [],
        personnelList: [], //人员列表
        showAddInsurance: false, //新增保单弹窗
        bntList: this.$store.state.EMP.bntList, //商保类别
        roletype: localStorage.loginRoletype,
        docPath: this.$store.state.EMP.docPath,
        gridData: [],
        gridloading: false,
        tableData2: [],
        showImportTemp: false, //上传模板弹窗
        Bntype: '', //商保类别
        tempForm: {
          id: '',
          FileBase64: '',
        },
        isUploadSuccess: false,
        fileName: '',
      }
    },
    created() {
      this.getInsurancManageList();
      this.getauthUserInfoByorgancode();
      this.getServiceList();
    },
    methods: {
      checkPermission,
      searchHandle() {
        if (this.activeName == 'first') {
          this.getInsurancManageList()
        } else if(this.activeName == 'second'){
          this.getOrderPolicyManageList();
        }else{
          this.getList();
        }
      },
      handleClick() {
        nextTick(() => {
          this.tableData = [];
          this.tableData2 = [];
        })
        if (this.activeName == 'first') {
          this.listQuery = {
            InsuranceName: '', //险种名称
            ServerName: '', //服务商
            Bntype: '', //商保类别
            pageNum: 1,
            pageSize: 10,
          }
          this.getInsurancManageList()
        } else if (this.activeName == 'second') {
          this.listQuery = {
            insurable: '',
            pageNum: 1,
            pageSize: 10,
          }
          this.getOrderPolicyManageList();
        } else if (this.activeName == '3') {
          this.listQuery = {
            beginTime: '',
            endTime: '',
            pageNum: 1,
            pageSize: 10,
          }
          this.getList();
        } else if (this.activeName == '4') {
          this.listQuery = {
            pageNum: 1,
            pageSize: 10,
          }
          this.getList();
        }
      },
      getList() {
        xz.BuildCheckList(this.listQuery, this.roletype, this.activeName == '3' ? 'BuildOrderList' : 'BuildCheckList').then(res => {
          if (res.status == 'ok') {
            this.tableData2 = res.data;
            this.totalCount = res.count;
          } else {
            this.tableData2 = []
            this.totalCount = 0;
          }
        })
      },
      //获取服务商列表
      getServiceList() {
        let data = {
          pageNum: 1,
          pageSize: 100000,
        }
        xz.getServiceProviderList(data, this.roletype).then(res => {
          if (res.status == "ok") {
            this.serviceList = res.data.list;
          } else {
            this.serviceList = [];
            this.$message.error('系统出错');
          }
        })
      },
      addNewPlan() {
        this.clear();
        this.showAddPlan = true;
      },
      clear() {
        this.planForm = {
          InsuranceManage: {
            id: '',
            ServerName: '', //服务商名称
            ProjectName: '', //商保险种名称
            InsuranceProduct: '', //投保产品
            AdditPlan: '', //附加险方案
            ProtecName: '', //保障方案名称
            Bntype: '', //商保类别
            Price: '', //投保金额
            ContactPerson: '', //对接人
            ContactPersonID: '',
            AttachmentUrl: '',
            ClaimsPrice: '', //理赔上限
            TypeWork: '', //工种类型
            SupportPeriodUnit: '', //保障周期单位
            SupportPeriod: '', //保障周期
            MaleRatio: '', //男性比例
            FemaleRatio: '', //女性比例
            AgelimitStart: '', //年龄限制
            AgelimitEnd: '', //年龄限制
            ValidityStartTime: '', //有效期
            ValidityEndTime: '', //有效期
            MedicalinsuranceType: '', //医保类型
            IsCanDeduction: '', //是否允许报减
            SafeguardStatement: '', //保障说明
            InsuranceAuthority: '', //权限范围
            Enabled: '启用中',
            EmployeeAttribute: '', //职业类别选项
            JobClasss: '', //职业类别批注
            JobName: '', //岗位批注
            Sort: null, //序号
          },
          distributionList: [], //可见账户
          CostList: [{
            JobCategory: '', //岗位类别
            PriceUnit: '', //价格单位
            Price: '', //价格
            CostUnit: '', ///成本单位
            Cost: '', //成本
            Remark: ''
          }]
        }
      },
      //选择人员
      changePerson(val) {
        this.planForm.InsuranceManage.ContactPersonID = val.Userid;
        this.planForm.InsuranceManage.ContactPerson = val.Username;
      },
      //取人员列表
      getauthUserInfoByorgancode() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        }
        xz.getauthUserInfoByorgancode(data).then(res => {
          if (res.status == "ok") {
            this.personnelList = res.msg;
          } else {
            this.$message.error('获取人员列表失败')
            this.personnelList = [];
          }
        })
      },
      //获取险种列表
      getInsurancManageList() {
        this.loading = true;
        xz.getInsurancManageList(this.listQuery, this.roletype).then(res => {
          if (res.status == "ok") {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.$message.error('系统出错')
            this.tableData = [];
            this.loading = false;
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.searchHandle();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.searchHandle();
      },
      //上传附件
      success_handle(file, fileList) {
        console.log(file, fileList);
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.planForm.InsuranceManage.AttachmentUrl = res
          } else {
            this.planForm.InsuranceManage.AttachmentUrl = ''
          }
        });
      },
      handleRemove(file) {
        this.planForm.AttachmentUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      //确认新增/编辑险种
      confirmSavePlan() {
        this.$refs["planForm"].validate((valid) => {
          if (valid) {
            if (this.planForm.InsuranceManage.TypeWork) {
              this.planForm.InsuranceManage.TypeWork = this.planForm.InsuranceManage.TypeWork.toString();
            }
            if (this.planForm.InsuranceManage.EmployeeAttribute) {
              this.planForm.InsuranceManage.EmployeeAttribute = this.planForm.InsuranceManage.EmployeeAttribute.toString();
            }
            if (this.planForm.distributionList) {
              this.planForm.distributionList = this.planForm.distributionList.toString();
            }
            if (this.planForm.InsuranceManage.Bntype) {
              this.planForm.InsuranceManage.Bntype = encodeURIComponent(this.planForm.InsuranceManage.Bntype)
            }
            if (this.planForm.InsuranceManage.ProtecName) {
              this.planForm.InsuranceManage.ProtecName = encodeURIComponent(this.planForm.InsuranceManage.ProtecName)
            }
            if (this.planForm.InsuranceManage.InsuranceProduct) {
              this.planForm.InsuranceManage.InsuranceProduct = encodeURIComponent(this.planForm.InsuranceManage.InsuranceProduct)
            }
            if (this.planForm.InsuranceManage.AdditPlan) {
              this.planForm.InsuranceManage.AdditPlan = encodeURIComponent(this.planForm.InsuranceManage.AdditPlan)
            }
            xz.editInsurancManage(this.planForm, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.getInsurancManageList();
                this.$message.success('保存成功')
                this.clear();
                this.showAddPlan = false;
              } else {
                this.$message.error('系统出错')
              }
            })
          }
        })
      },
      //新增成本
      addCost() {
        let item = {
          JobCategory: '', //岗位类别
          PriceUnit: '', //价格单位
          Price: '', //价格
          CostUnit: '', ///成本单位
          Cost: '', //成本
          Remark: ''
        }
        this.planForm.CostList.push(item)
      },
      //删除
      delCost(index) {
        this.planForm.CostList.splice(index, 1);
      },
      //编辑险种
      editPlan(row) {
        xz.getInsurancManage(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (res.data.CostList.length == 0) {
              res.data.CostList = [{
                JobCategory: '', //岗位类别
                PriceUnit: '', //价格单位
                Price: '', //价格
                CostUnit: '', ///成本单位
                Cost: '', //成本
                Remark: ''
              }]
            }
            if (res.data.InsuranceManage.TypeWork) {
              res.data.InsuranceManage.TypeWork = res.data.InsuranceManage.TypeWork.split(',')
            }
            if (res.data.InsuranceManage.EmployeeAttribute) {
              res.data.InsuranceManage.EmployeeAttribute = res.data.InsuranceManage.EmployeeAttribute.split(',')
            }
            if (res.data.distributionList.length > 0) {
              let arr = [];
              res.data.distributionList.forEach((element, index) => {
                arr.push(element.BusinessUserId)
                if (index + 1 == res.data.distributionList.length) {
                  res.data.distributionList = arr;
                }
              });
            }
            this.planForm = res.data;
            this.showAddPlan = true;
          } else {
            this.$message.error('获取详情出错')
          }
        })
      },
      //停用/启用
      stopPlan(row) {
        console.log(row)
        let data = {
          id: row.Id,
          Enabled: row.Enabled == '已停用' ? '启用中' : '已停用'
        }
        xz.editInsurancManageEnabled(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getInsurancManageList();
            this.$message.success('操作成功！')
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //删除险种
      delPlan(row) {
        xz.delInsurancManage(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getInsurancManageList();
            this.$message.success('删除成功！')
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      down(url) {
        const aTag = document.createElement('a')
        aTag.href = url
        aTag.click();
      },
      getPhone(id) {
        this.gridData = [];
        this.gridloading = true;
        let dtlQuery = {
          mainuserid: '',
          useridr: id
        }
        xz.getauthJbUserDetail(dtlQuery).then(res => {
          if (res.status == 'ok') {
            this.gridData = [{
              phone: res.msg.Strmobile
            }]
            this.gridloading = false;
          } else {
            this.$message.error('获取联系方式失败')
            this.gridData = []
            this.gridloading = false;
          }
        })
      },
      //获取订单/保单
      getOrderPolicyManageList() {
        this.loading = true;
        xz.getOrderPolicyManageList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.tableData2 = res.data.list;
            this.totalCount = res.data.totalcount;
            console.log(res)
          } else {
            this.$message.error('获取联系方式失败')
            this.tableData2 = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //上传模板
      importTemp(row) {
        this.tempForm.id = row.Id;
        this.Bntype = row.Bntype;
        this.showImportTemp = true;
      },
      //文件读取
      async importf() {
        const fileInput = this.$refs.upload;
        this.fileName = fileInput.files[0].name;
        FUN.fileToBase64(fileInput.files[0]).then(res => {
          if (res) {
            this.tempForm.FileBase64 = res;
            this.isUploadSuccess = true;
          } else {
            this.$message("上传Excel失败!");
            this.isUploadSuccess = false;
            this.$refs['upload'].value = null;
          }
        })
      },
      confirmImportTemp() {
        xz.templateFileUpload(this.tempForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$refs['upload'].value = null;
            this.fileName = '';
            this.tempForm.FileBase64 = '';
            this.$message.success('模板上传成功！');
            this.showImportTemp = false;
          } else {
            this.$message.error('模板上传失败');
            this.fileName = '';
            this.$refs['upload'].value = null;
            this.tempForm.FileBase64 = '';
            this.showImportTemp = false;
          }
        })
      },
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      generateNum() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach(e => {
            arr.push(e.Id)
          });
          this.loading = true;
          let ids = arr.toString();
          xz.BuildOrder(ids, this.roletype)
          this.$message.success('保单生成中，请等待5~10分钟')
        } else {
          this.$message.warning('请至少选择一条')
        }
      },
      BuildTime(pagename) {
        xz.BuildTime(pagename)
        this.$message.success('生成中，请等待5~10分钟')
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .priceBox {
    margin-top: 10px;
    border-top: 1px solid #ccc;
    padding-top: 10px;
  }

  .formTitle {
    margin: 20px 0;
    font-size: 18px;
    font-weight: 500;
    color: #000;
  }

  .txtBtb {
    height: 40px;
    line-height: 40px;
    font-size: 13px;
  }

  .addCost {
    margin-left: 60px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
<style>
  .page_programme .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_programme .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_programme .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_programme .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_programme .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_programme .planForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_programme .planForm .el-form-item__error {
    top: 34px;
  }
</style>